import { render, staticRenderFns } from "./newsucursal.vue?vue&type=template&id=f0674618&scoped=true"
import script from "./newsucursal.vue?vue&type=script&lang=js"
export * from "./newsucursal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0674618",
  null
  
)

export default component.exports